import { AdMobPlugin } from '@capacitor-community/admob'
import { Plugins } from '@capacitor/core'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const AdMob: AdMobPlugin = (Plugins as any).AdMob
